import type { MetricSeries } from '../MetricChart/types'

/**
 * Builds an accessible name for a metric line chart from its series — the primary
 * metric titles (comparison siblings excluded) joined with "and", suffixed with
 * "over time" (e.g. "Views and Followers over time"). Falls back to a generic
 * label when there are no primary series.
 */
export function buildLineChartAriaLabel(metrics: MetricSeries[]): string {
  const titles = metrics
    .filter((m) => !m.key.endsWith('-comparison'))
    .map((m) => m.title)
  if (titles.length === 0) return 'Metrics over time'
  return `${titles.join(' and ')} over time`
}
